import apiCall from '../../../apiCall/apiCall';
import buildGetQuery from '../../../helpers/buildGetQuery/buildGetQuery';

class Supplier {
  static all(params) {
    const data = buildGetQuery(params);
    return apiCall('GET', 'financials/suppliers', data);
  }

  static show(accountRef) {
    if (!accountRef)
      return new Promise((_, reject) =>
        reject({
          error: 'This entity does not specify a supplier account reference',
          status: null,
        }),
      );
    return apiCall('GET', `financials/suppliers/${accountRef}`);
  }
}

export default Supplier;
